import React from "react";
import { Modal, Button, Typography, Spin } from "antd";

function QuickWordPublishDialog({
  open,
  onClose,
  selectedCommand,
  onPublish,
  isProcessing,
}) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Publish Command"
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="publish"
          type="primary"
          onClick={onPublish}
          disabled={isProcessing === "publish"}
          loading={isProcessing === "publish"}
        >
          Publish
        </Button>,
      ]}
    >
      <Typography.Text>
        Are you sure you want to publish the command &quot;
        {selectedCommand?.id}&quot;? This will make it available in
        production.
      </Typography.Text>
    </Modal>
  );
}

export default QuickWordPublishDialog;
